
//quantity

document.addEventListener("click", function (event) {
    if (event.target.matches(".quantity-increase")) {
      let input = event.target.closest(".side-cart-item__quantity").querySelector(".quantity-input");
      input.value = parseInt(input.value) + 1;
      input.dispatchEvent(new Event("change"));
    }
  
    if (event.target.matches(".quantity-decrease")) {
      let input = event.target.closest(".side-cart-item__quantity").querySelector(".quantity-input");
      if (parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
        input.dispatchEvent(new Event("change"));
      }
    }
  });

  
  document.addEventListener('DOMContentLoaded', function () {
    const thumbSlider = new Swiper('.thumbnail-slider', {
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true
    });
  
    window.mainSlider = new Swiper('.main-slider', {
      spaceBetween: 10,
      autoHeight: true,
      thumbs: { swiper: thumbSlider },
    });
  
    function initProductGallery() {
      const thumbSlider = new Swiper('.thumbnail-slider', {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        watchSlidesProgress: true
      });
    
      window.mainSlider = new Swiper('.main-slider', {
        spaceBetween: 10,
        autoHeight: true,
        thumbs: { swiper: thumbSlider },
      });
    }
    
    // Run once on DOM ready
    document.addEventListener('DOMContentLoaded', initProductGallery);
    
    // Live update in Theme Editor
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initProductGallery);
      document.addEventListener('shopify:section:select', initProductGallery);
      document.addEventListener('shopify:section:deselect', initProductGallery);
      document.addEventListener('shopify:block:select', initProductGallery);
      document.addEventListener('shopify:block:deselect', initProductGallery);
    }
  })

  function initProductZoom() {
  const elements = document.querySelectorAll(".product-image, .product-video");

  // Remove duplicate events by cloning
  elements.forEach(el => el.replaceWith(el.cloneNode(true)));

  // Re-select clean elements
  const media = document.querySelectorAll(".product-image, .product-video");

  media.forEach(el => {
    const container = el.closest(".product-page-container");
    if (!container) return;

    /* -------------------------------------------------------------------
       Ensure wrapper exists (for zoom + overflow control)
    ------------------------------------------------------------------- */
    let wrapper = el.closest(".media-wrapper");
    if (!wrapper) {
      const wrap = document.createElement("div");
      wrap.classList.add("media-wrapper");
      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(el);
      wrapper = wrap;
    }
    wrapper.style.overflow = "hidden";


    /* -------------------------------------------------------------------
       MODE 1: INNER ZOOM (zoom-mode-hover_click)
    ------------------------------------------------------------------- */
    if (container.classList.contains("zoom-mode-hover_click")) {
      let zoomed = false;

      // CLICK → toggle zoom
      wrapper.addEventListener("click", () => {
        zoomed = !zoomed;

        if (zoomed) {
          wrapper.classList.add("zoom-active");
          el.style.cursor = "zoom-out";
        } else {
          wrapper.classList.remove("zoom-active");
          el.style.transform = "scale(1)";
          el.style.cursor = "zoom-in";
        }
      });

      // MOUSEMOVE → follow cursor
      wrapper.addEventListener("mousemove", (e) => {
        if (!zoomed) return;

        const rect = wrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        el.style.transformOrigin = `${x}% ${y}%`;
        el.style.transform = "scale(2.2)";
      });

      // LEAVE → reset if not clicked zoom
      wrapper.addEventListener("mouseleave", () => {
        if (!zoomed) {
          el.style.transform = "scale(1)";
        }
      });

      return; // bypass lightbox mode
    }


    /* -------------------------------------------------------------------
       MODE 2: LIGHTBOX ZOOM (zoom-mode-lightbox)
    ------------------------------------------------------------------- */
    if (container.classList.contains("zoom-mode-lightbox")) {
      el.style.cursor = "zoom-in";

      // Lightbox for IMAGES
      if (el.tagName.toLowerCase() === "img") {
        el.addEventListener("click", () => {
          const lightbox = document.createElement("div");
          lightbox.className = "lightbox";

          lightbox.innerHTML = `
            <div class="lightbox-content">
              <button class="lightbox-close">×</button>
              <img src="${el.src}" class="lightbox-img">
            </div>
          `;

          document.body.appendChild(lightbox);
          lightbox.querySelector(".lightbox-close").addEventListener("click", () => lightbox.remove());
        });
      }

      // Lightbox for VIDEOS
      if (el.tagName.toLowerCase() === "video") {
        el.addEventListener("click", () => {
const src = el.currentSrc || el.src || el.querySelector("source")?.src;

          const lightbox = document.createElement("div");
          lightbox.className = "lightbox";

          lightbox.innerHTML = `
            <div class="lightbox-content">
              <button class="lightbox-close">×</button>
              <video class="lightbox-video" controls autoplay playsinline muted>
                <source src="${src}" type="video/mp4">
              </video>
            </div>
          `;


          document.body.appendChild(lightbox);
          lightbox.querySelector(".lightbox-close").addEventListener("click", () => lightbox.remove());
        });
      }

      return;
    }


    /* -------------------------------------------------------------------
       MODE 3: NONE (zoom-mode-none)
    ------------------------------------------------------------------- */
    if (container.classList.contains("zoom-mode-none")) {
      el.style.cursor = "default";
    }
  });
}


  // Initial run
  document.addEventListener("DOMContentLoaded", initProductZoom);
  
  // Re-run when Shopify editor settings change live
  document.addEventListener('shopify:section:select', initProductZoom);
  document.addEventListener('shopify:section:load', initProductZoom);
  document.addEventListener('shopify:section:unload', initProductZoom);
  document.addEventListener('shopify:section:reorder', initProductZoom);
  
  
  const variantsData = JSON.parse(document.getElementById('product-variants-json').textContent);
  
  function updateVariantId() {
    const selectedOptions = [];
    document.querySelectorAll('.variant-option').forEach((option, i) => {
      const pills = option.querySelector('.variant-pills input:checked');
      const dropdown = option.querySelector('.variant-dropdown');
      const value = pills ? pills.value : dropdown.value;
      selectedOptions.push(value);
    });
  
    const match = variantsData.find(v => v.options.every((o, i) => o === selectedOptions[i]));
    if(match) document.querySelector('.selected-variant-id').value = match.id;
  }
  
  document.querySelectorAll('.variant-pills input').forEach(input => input.addEventListener('change', updateVariantId));
  // document.querySelectorAll('.variant-dropdown').forEach(select => select.addEventListener('change', updateVariantId));
  
  
  document.querySelectorAll('.share-button').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.nextElementSibling;
      input.style.display = 'block';
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand('copy'); // Copy the link
      button.textContent = 'Link Copied!';
      setTimeout(() => {
        button.textContent = button.dataset.originalText || 'Share this product';
        input.style.display = 'none';
      }, 2000);
    });
  
    // Store original text for reset
    button.dataset.originalText = button.textContent;
  });
  document.addEventListener('DOMContentLoaded', function() {
  const buyNowBtn = document.querySelector('.buy-now');
  if (!buyNowBtn) return;

  buyNowBtn.addEventListener('click', function () {
    // Grab the first product form on the page (adjust selector if needed)
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const formData = new FormData(form);

    // 1. Add item to cart
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => res.json())
    .then(() => {
      // 2. Redirect straight to checkout
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.error('Buy Now error:', err);
    });
  });
});
  
  document.addEventListener("DOMContentLoaded", function() {
  const shareToggles = document.querySelectorAll(".share-toggle");

  shareToggles.forEach(function(toggle) {
    toggle.addEventListener("click", function() {
      const input = this.nextElementSibling; // the input field
      if (input.style.display === "none") {
        input.style.display = "block";
        input.select();
        input.setSelectionRange(0, 99999); // for mobile devices
        document.execCommand("copy"); // copy to clipboard
        // no alert
      } else {
        input.style.display = "none";
      }
    });
  });
});